var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.loadingAccessTokenDone
        ? _c("loading-page", { attrs: { text: "Logging in..." } })
        : _vm.loadingAccessTokenDone
        ? _c(
            "v-container",
            { staticClass: "pa-0", staticStyle: { height: "100%" } },
            [
              _c(
                "v-row",
                {
                  staticClass: "overflowY-auto",
                  staticStyle: { width: "100%", height: "100vh" },
                  attrs: { "no-gutters": "" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticStyle: { margin: "auto" },
                      attrs: { cols: "12", xl: "4", lg: "6", md: "7", sm: "9" },
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "mb-8", attrs: { justify: "center" } },
                        [
                          _c("v-img", {
                            attrs: {
                              src: "/img/dynamic-src-images/logos/SVG-logo.svg",
                              "max-width":
                                _vm.$vuetify.breakpoint.width > 390
                                  ? "385"
                                  : "315",
                              height: "171",
                              contain: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card",
                        {
                          staticClass: "card-shadow mb-12 mx-5",
                          staticStyle: {
                            background: "#fff",
                            border: "1px solid rgb(218, 220, 224, 0.5)",
                          },
                        },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "simple-slow-opacityAN py-1" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "pb-2",
                                  attrs: { justify: "center" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6", sm: "5" } },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "sign-in mb-0 pt-2",
                                          staticStyle: {
                                            "margin-top": "auto",
                                            color: "#424242",
                                          },
                                        },
                                        [_vm._v(" Sign in ")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                { attrs: { justify: "center" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "10", sm: "8" } },
                                    [
                                      _c(
                                        "v-form",
                                        {
                                          ref: "loginForm",
                                          model: {
                                            value: _vm.loginForm,
                                            callback: function ($$v) {
                                              _vm.loginForm = $$v
                                            },
                                            expression: "loginForm",
                                          },
                                        },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "text-field-text",
                                            attrs: {
                                              autofocus: "",
                                              light: "",
                                              dense: "",
                                              outlined: "",
                                              label: "Username or e-mail",
                                              rules: [_vm.rules.required],
                                              autocomplete: "",
                                            },
                                            on: { keypress: _vm.keypressed },
                                            model: {
                                              value: _vm.credentials.username,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.credentials,
                                                  "username",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "credentials.username",
                                            },
                                          }),
                                          _c("v-text-field", {
                                            staticClass: "text-field-text",
                                            attrs: {
                                              light: "",
                                              dense: "",
                                              outlined: "",
                                              label: "Password",
                                              type: "password",
                                              rules: [_vm.rules.required],
                                              autocomplete: "",
                                            },
                                            on: { keypress: _vm.keypressed },
                                            model: {
                                              value: _vm.credentials.password,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.credentials,
                                                  "password",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "credentials.password",
                                            },
                                          }),
                                          _vm.error
                                            ? _c(
                                                "v-row",
                                                {
                                                  attrs: { justify: "center" },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass:
                                                        "red--text mr-1",
                                                      staticStyle: {
                                                        height: "20px",
                                                      },
                                                      attrs: { small: "" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "fas fa-exclamation-circle"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.errorType ==
                                                  _vm.errorEnums.NETWORKERROR
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "red--text mb-3",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Network error. "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm.errorType ===
                                                      _vm.errorEnums.ER401
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "red--text mb-3 text-center",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Username or password are incorrect. "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm.errorType ===
                                                      _vm.errorEnums
                                                        .CUSTOM_TIMEOUT
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "red--text mb-3 text-center",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Request took too long, please try again. "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm.sessionExpired
                                                    ? _c(
                                                        "v-col",
                                                        { staticClass: "py-0" },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "red--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Your session has expired. Please sign in again. "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "red--text mb-3",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Something went wrong!"
                                                          ),
                                                        ]
                                                      ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "v-row",
                                            { attrs: { justify: "center" } },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "text-center",
                                                  attrs: {
                                                    cols: "11",
                                                    xl: "4",
                                                    lg: "6",
                                                    md: "7",
                                                    sm: "9",
                                                  },
                                                },
                                                [
                                                  !_vm.loading || _vm.error
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.loginRemote,
                                                          },
                                                        },
                                                        [_vm._v("Sign In")]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-center mx-auto",
                                                          staticStyle: {
                                                            width: "89px",
                                                            height: "36px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-progress-circular",
                                                            {
                                                              staticClass:
                                                                "mt-2",
                                                              attrs: {
                                                                indeterminate:
                                                                  "",
                                                                color:
                                                                  "primary",
                                                                size: 24,
                                                                width: 3,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }